<div class="fuse-drawer-content" [ngClass]="customClass">
    <ng-content></ng-content>
</div>